(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('[data-copy-spec]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true'; button.hidden = false;
      button.addEventListener('click', async () => {
        const clause = document.getElementById(button.dataset.copySpec);
        const status = button.closest('.pa-clause-card').querySelector('[role="status"]');
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(clause.textContent.trim());
          status.textContent = 'Specification copied. Complete the bracketed project details before use.';
        } catch {
          const range = document.createRange(); range.selectNodeContents(clause);
          const selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range);
          clause.focus(); status.textContent = 'Text selected. Use your device’s Copy command, or save it as a text file.';
        }
      });
    });
    root.querySelectorAll('[data-download-spec]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true'; button.hidden = false;
      button.addEventListener('click', () => {
        const text = document.getElementById(button.dataset.downloadSpec).textContent.trim();
        const product = button.dataset.productName || 'Protector';
        const blob = new Blob([product+' — suggested specification\n\n'+text+'\n\nComplete bracketed project details and confirm the current model-specific drawings and manufacturer instructions.\nProtector Australia | 1300 585 787 | sales@protector.com.au\n'], {type:'text/plain;charset=utf-8'});
        const url = URL.createObjectURL(blob); const link = document.createElement('a');
        link.href = url; link.download = product.replace(/[^a-z0-9]+/gi,'-')+'-specification.txt';
        document.body.append(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),10000);
      });
    });
    root.querySelectorAll('[data-pa-filter]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const buttons=[...section.querySelectorAll('[data-category]')];
      const input=section.querySelector('[data-filter-search]');
      const cards=[...section.querySelectorAll('[data-filter-item]')];
      const count=section.querySelector('[data-filter-count]');
      const empty=section.querySelector('[data-filter-empty]');
      section.querySelector('.pa-filter-bar').hidden=false;
      if(input)input.closest('.pa-search-field').hidden=false;
      let active='all';
      const update=()=>{
        const query=(input?.value||'').toLocaleLowerCase('en-AU').trim();let shown=0;
        cards.forEach(card=>{
          const matches=(active==='all'||card.dataset.filterCategory.split('|').includes(active))&&card.textContent.toLocaleLowerCase('en-AU').includes(query);
          card.hidden=!matches;if(matches)shown++;
        });
        buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.category===active)));
        if(count)count.textContent=shown+' of '+cards.length+' '+(section.dataset.filterNoun||'results');
        if(empty)empty.hidden=shown!==0;
      };
      buttons.forEach(button=>button.addEventListener('click',()=>{active=button.dataset.category;update()}));
      input?.addEventListener('input',update);update();
    });
    root.querySelectorAll('[data-message-carousel]').forEach(hero => {
      if (hero.dataset.messagesReady) return;
      hero.dataset.messagesReady='true';
      const slides=[...hero.querySelectorAll('.pa-hero-message')];
      const controls=hero.querySelector('.pa-message-controls');
      const buttons=[...controls.querySelectorAll('[data-message-index]')];
      const pause=controls.querySelector('.pa-message-pause');
      const media=window.matchMedia('(prefers-reduced-motion: reduce)');
      let index=0,userPaused=media.matches,hovered=false,focused=false,visible=true,timer;
      controls.hidden=false;
      const show=(next)=>{
        index=next; slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===index);slide.setAttribute('aria-hidden',String(i!==index))});
        buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
      };
      const sync=()=>{
        clearTimeout(timer);
        pause.textContent=userPaused?'Play messages':'Pause messages';pause.setAttribute('aria-pressed',String(userPaused));
        if(!userPaused&&!hovered&&!focused&&visible&&!document.hidden){timer=setTimeout(()=>{show((index+1)%slides.length);sync()},Number(hero.dataset.messageInterval)||6500)}
      };
      buttons.forEach((button,i)=>button.addEventListener('click',()=>{show(i);userPaused=true;sync()}));
      pause.addEventListener('click',()=>{userPaused=!userPaused;sync()});
      const enter=()=>{hovered=true;sync()},leave=()=>{hovered=false;sync()};
      hero.addEventListener('mouseenter',enter);hero.addEventListener('mouseleave',leave);
      hero.addEventListener('focusin',()=>{focused=true;sync()});
      hero.addEventListener('focusout',event=>{if(!hero.contains(event.relatedTarget)){focused=false;sync()}});
      const motion=()=>{userPaused=media.matches;sync()};media.addEventListener('change',motion);
      document.addEventListener('visibilitychange',sync);
      const observer=new IntersectionObserver(([entry])=>{visible=entry.isIntersecting;sync()},{threshold:.05});observer.observe(hero);
      hero._paMessageCleanup=()=>{clearTimeout(timer);observer.disconnect();media.removeEventListener('change',motion);document.removeEventListener('visibilitychange',sync)};
      show(0);sync();
    });
    const params=new URLSearchParams(window.location.search);
    const form=root.querySelector('#ContactForm');
    if(form&&params.has('product')){
      const body=form.querySelector('[name="contact[body]"]');
      if(body&&!body.value)body.value='I would like '+(params.get('request')==='specification'?'a project-specific specification for ':'to discuss ')+params.get('product').slice(0,120)+'.\n\nProject location:\nDesign flow / required capacity:\nProject stage:\n';
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialise(),{once:true});else initialise();
  document.addEventListener('shopify:section:load',event=>initialise(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-message-carousel]').forEach(hero=>hero._paMessageCleanup?.()));
})();
